import {
  EdgeProps as FlowEdgeProps,
  NodeProps as FlowNodeProps,
} from '@xyflow/react';

export type EdgeProps = FlowEdgeProps & {};

export type NodeProps = FlowNodeProps & {};

export enum GraphNode {
  Generic = 'generic',
  Terminal = 'terminal',
}

export enum GraphEdge {
  Default = 'default',
}
